import { twMerge } from 'tailwind-merge';
import { NormalizedIProduct } from '@snackpass/snackpass-types';
interface TileProps {
    item: NormalizedIProduct;
    tileSize: number;
    tileColor: string;
    textColor: string;
    priceColor: string;
}

export function Tile({
    item,
    tileSize,
    tileColor,
    textColor,
    priceColor,
}: TileProps) {
    return (
        <div
            style={{
                width: tileSize,
                height: tileSize,
            }}
            className="relative flex flex-col justify-start items-center rounded-none px-[.25em]"
        >
            {item.image ? (
                <img
                    className={twMerge(
                        'object-cover w-4/5 h-4/5 object-center rounded-[1em]',
                        item.soldOut ? 'grayscale' : ''
                    )}
                    src={item.image}
                    alt={item.name}
                />
            ) : (
                <div
                    className="w-4/5 h-4/5 rounded-[1em]"
                    style={{
                        backgroundColor: tileColor,
                    }}
                ></div>
            )}
            <div className="w-4/5 mt-[.5em]">
                <p
                    className={twMerge(
                        'font-medium leading-snug text-neutral-400'
                    )}
                    style={{
                        color: !item.soldOut ? textColor : undefined,
                    }}
                >
                    {item.name}
                </p>
                <p
                    className={'font-medium leading-snug text-neutral-400'}
                    style={{
                        color: !item.soldOut ? priceColor : undefined,
                    }}
                >
                    {`$${item.price.toFixed(2)}`} {item.soldOut && '(Sold Out)'}
                </p>
            </div>
        </div>
    );
}
